export default function CaseResults() {
  return (
    <section id="cases" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Результаты наших клиентов
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Измеримые бизнес-показатели после внедрения программы выявления потребностей.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          <div className="bg-gray-50 rounded-2xl p-6 md:p-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 overflow-hidden rounded-xl bg-teal-100 flex items-center justify-center flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20corporate%20office%20interior%20modern%20logistics%20company%20headquarters%20with%20team%20working%20at%20desks%20warm%20natural%20lighting%20clean%20elegant%20design%20glass%20partitions%20industrial%20details&width=200&height=200&seq=needs-logistics&orientation=squarish"
                  alt="Логистическая компания"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-xs font-semibold text-teal-600 tracking-wider mb-1">КЕЙС 1</div>
                <h3 className="text-base font-bold text-gray-900">Логистическая компания</h3>
              </div>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed mb-5">
              Менеджеры продавали перевозки как стандартную услугу, не выявляя специфику груза и скрытые требования клиента. После внедрения методики SPIN и практики на реальных звонках.
            </p>
            <div className="bg-teal-600/10 rounded-xl p-4 text-center">
              <div className="text-3xl font-extrabold text-teal-600 mb-1">18–23%</div>
              <div className="text-sm text-gray-600">рост конверсии месяц к месяцу</div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-6 md:p-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 overflow-hidden rounded-xl bg-teal-100 flex items-center justify-center flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20bright%20retail%20store%20interior%20with%20professional%20sales%20consultant%20engaging%20with%20customer%20warm%20friendly%20atmosphere%20natural%20lighting%20clean%20minimalist%20design%20white%20walls%20with%20wooden%20accents%20contemporary%20commercial%20space&width=200&height=200&seq=needs-b2c&orientation=squarish"
                  alt="B2C-продажи"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-xs font-semibold text-teal-600 tracking-wider mb-1">КЕЙС 2</div>
                <h3 className="text-base font-bold text-gray-900">B2C-продажи</h3>
              </div>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed mb-5">
              Розничные менеджеры работали по принципу «покажи и расскажи». После обучения выявлению потребностей — научились определять истинный запрос клиента, что привело к росту среднего чека.
            </p>
            <div className="bg-teal-600/10 rounded-xl p-4 text-center">
              <div className="text-3xl font-extrabold text-teal-600 mb-1">55%</div>
              <div className="text-sm text-gray-600">рост конверсии в покупку</div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-6 md:p-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 overflow-hidden rounded-xl bg-teal-100 flex items-center justify-center flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20customer%20support%20call%20center%20office%20interior%20with%20team%20of%20professionals%20assisting%20international%20clients%20warm%20atmosphere%20clean%20design%20with%20plants%20natural%20light%20professional%20environment%20global%20service%20company&width=200&height=200&seq=needs-israel&orientation=squarish"
                  alt="Israel Assist"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-xs font-semibold text-teal-600 tracking-wider mb-1">КЕЙС 3</div>
                <h3 className="text-base font-bold text-gray-900">Israel Assist</h3>
              </div>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed mb-5">
              Компания международного медицинского страхования. Менеджеры работали с продлением полисов. После тренинга научились выявлять неудовлетворённость клиентов текущим сервисом и предлагать релевантные решения.
            </p>
            <div className="bg-teal-600/10 rounded-xl p-4 text-center">
              <div className="text-3xl font-extrabold text-teal-600 mb-1">64 → 84%</div>
              <div className="text-sm text-gray-600">рост продлений полисов</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}